export const COVERED_ITEMS = [
  'Air Conditioner',
  'Built-in Microwave',
  'Dishwasher',
  'Ductwork',
  'Electrical Systems',
  'Furnace',
  'Garbage Disposal',
  'Plumbing',
  'Range/Oven',
  'Refrigerator',
  'Washer/Dryer',
  'Water Softener',
] as const;
